import { useCommunityGoal, useCreator } from '@hotpot-arcade/fanforge-meta-client';
import clsx from 'clsx';

export const CommunityBadge = ({ inGame }: { inGame?: boolean }) => {
  const { data: creator } = useCreator();
  const { data: communityGoal } = useCommunityGoal();
  if (!creator) return null;

  return (
    <div
      className={clsx('flex flex-row gap-3 items-center justify-between py-1 px-2 bg-dark-2 rounded-lg', {
        'justify-start w-[200px]': inGame && communityGoal,
      })}
    >
      <img src={creator.iconUrl} className="w-8 h-8 rounded-full" />
      {communityGoal ? (
        <div className={clsx('flex flex-col gap-1 w-fit', { 'w-full': inGame })}>
          {!inGame && (
            <div className="flex flex-row justify-between gap-4 w-fit">
              <p className="text-white font-bold text-xs">{creator.discordGuildName}</p>
              <p className="text-white text-xs">
                {communityGoal.points}/{communityGoal.totalPointsToNextLevel} XP
              </p>
            </div>
          )}
          <div className="flex flex-row items-center justify-center gap-2">
            <p className="bg-dark-5 px-[4px] py-[1px] text-white font-bold text-sm rounded-sm whitespace-nowrap rounded-lg">
              LV {communityGoal.completedLevels + 1}
            </p>
            <div className="w-full bg-dark-5 h-[8px] rounded-2xl">
              <div
                className="rounded-2xl h-full bg-[linear-gradient(90deg,#1AB8FF_9.57%,#E2FF70_51.38%,#FF59E1_93.18%)]"
                style={{ width: `${(communityGoal.points * 100) / communityGoal.totalPointsToNextLevel}%` }}
              ></div>
            </div>
          </div>
        </div>
      ) : (
        <p className="text-white font-bold">{creator.discordGuildName}</p>
      )}
    </div>
  );
};
